import { isDevelopment } from 'common/constants/env'

export const resolveEventCreatorTemplateId = (selectedTemplateId, useScratchTemplate = isDevelopment) =>
    useScratchTemplate ? null : selectedTemplateId
